// extracted by mini-css-extract-plugin
export default {"table":"EditClientBalanceTable_table__jXFPw"};